module.exports = __webpack_public_path__ + "img/6_57.0828a7cb.png";